import { render, staticRenderFns } from "./AgencyContactsWallet.vue?vue&type=template&id=41da293b&"
import script from "./AgencyContactsWallet.vue?vue&type=script&lang=js&"
export * from "./AgencyContactsWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports